import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { endOfMonth, startOfMonth } from 'date-fns';
import PropTypes from 'prop-types';
import SmartCard from '../../../shared/components/SmartCard';
import {
  listBalanceSmartPay,
  accountValues,
} from '../../../shared/queries/BalanceSmartPay';
import GraphQL from '../../../GraphQL';
import MaterialTable from '../../../shared/components/material-table';
import columns from './ColumnsBalanceSmartPay';
import BalanceSmartPayFilter from './BalanceSmartPayFilter';
import BottomBarInfoBalanceSmartPay from './BottomBarInfoBalanceSmartPay';
import { formatCurrency } from '../../../shared/utils/smartutils';

const BalanceSmartPay = ({ t }) => {
  const [data, setData] = useState([]);
  const [valueInTransit, setValueInTransit] = useState(0);
  const [currentBalance, setCurrentBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const [lastFilter, setLastFilter] = useState(null);

  const onFilterToggle = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const applyFilter = (filter) => {
    if (filterIsOpen) {
      onFilterToggle();
    }
    setLoading(true);
    const query = listBalanceSmartPay(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.listAccountStatement) {
          setLoading(false);
          res.listAccountStatement.listOfTransactions =
            res.listAccountStatement.listOfTransactions.map((transaction) => ({
              ...transaction,
              formattedValue: formatCurrency(transaction.value),
            }));
          setData(res.listAccountStatement.listOfTransactions);
          setValueInTransit(res.listAccountStatement.valueInTransit);
        }
      })
      .catch(() => {});
  };

  const loadBalance = () => {
    const query = accountValues();
    GraphQL(query, {})
      .then((res) => {
        if (res.accountValues) {
          setCurrentBalance(res.accountValues.balance);
        }
      })
      .catch(() => {});
  };

  const onFilterClickHandler = (filter) => {
    if (filter) {
      setLastFilter(filter);
      applyFilter(filter);
    } else if (lastFilter) {
      applyFilter(lastFilter);
    }
  };

  const filterBuildFunction = () => (
    <BalanceSmartPayFilter
      isFiltering={filterIsOpen}
      filterClick={onFilterClickHandler}
      lastFilter={lastFilter}
    />
  );

  useEffect(() => {
    applyFilter({
      initialDate: startOfMonth(new Date()),
      finalDate: endOfMonth(new Date()),
    });
    loadBalance();
  }, []);

  return (
    <SmartCard>
      <Row className="Table">
        <Col md={12} lg={12}>
          <div className="material-table__wrap">
            <MaterialTable
              data={data}
              title={t('panels.balance-smartpay')}
              showTitle={false}
              columns={columns(t)}
              showFilter
              isFiltering={filterIsOpen}
              filterToggle={onFilterToggle}
              filterBuildFunction={filterBuildFunction}
              isLoading={loading}
              paging={false}
              minBodyHeight={291}
              maxBodyHeight={291}
              rowStyle={(rowData, i) => ({
                backgroundColor: i % 2 === 0 ? '#FFF' : '#FFF9E0',
              })}
            />
          </div>
        </Col>
      </Row>
      <BottomBarInfoBalanceSmartPay
        valueInTransit={valueInTransit}
        currentBalance={currentBalance}
      />
    </SmartCard>
  );
};

BalanceSmartPay.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(BalanceSmartPay);
